export const NAME_REGEX = /^[^[[()@\]]+$/;
